import { useFavoriteToggleContext } from '#baseMenu/components';
import { useAdvertFavoriteVisibleControl } from '#advertFavorite/hooks';

const useFavoriteToggleHandlerClick = () => {
  const { isOpen, open, hide } = useAdvertFavoriteVisibleControl();
  const {
    AdvertFavoriteBottomSheet,
    isLoaded,
    setIsLoaded,
    setIsLoadInProcess,
  } = useFavoriteToggleContext();

  return () => {
    if (!isLoaded) {
      setIsLoadInProcess(true);
      AdvertFavoriteBottomSheet.load().then(() => {
        setIsLoaded(true);
        setIsLoadInProcess(false);
        open();
      });
      return;
    }

    if (isOpen) {
      hide();
    } else {
      open();
    }
  };
};

export { useFavoriteToggleHandlerClick };
